import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Tooltip, OverlayTrigger, DropdownButton, MenuItem } from 'react-bootstrap'
import { injectIntl } from 'react-intl'
import messages from './messages'

import APPURL from 'utils/app/urls'

class ContentChartFooter extends Component {
  constructor(props) {
    super(props)
    const {
      intl: { formatMessage }
    } = props
    this.formatMessage = formatMessage

    this.state = {}

    this.showLegendButton = React.createRef()
    this.showByGenderButton = React.createRef()
    this.showTableButton = React.createRef()
    this.openModalButton = React.createRef()
    this.exportChartButton = React.createRef()
    this.expandChartButton = React.createRef()

    this.showLegendTooltip = <Tooltip id="showLegendTooltip">{this.formatMessage(messages.showLegendTooltip)}</Tooltip>
    this.showByGenderTooltip = <Tooltip id="showByGenderTooltip">{this.formatMessage(messages.showByGenderTooltip)}</Tooltip>
    this.showTableTooltip = <Tooltip id="showTableTooltip">{this.formatMessage(messages.showTableTooltip)}</Tooltip>
    this.openModalTooltip = <Tooltip id="openModalTooltip">{this.formatMessage(messages.openModalTooltip)}</Tooltip>
    this.exportChartTooltip = <Tooltip id="exportChartTooltip">{this.formatMessage(messages.exportChartTooltip)}</Tooltip>
    this.expandChartTooltip = <Tooltip id="expandChartTooltip">{this.formatMessage(messages.expandChartTooltip)}</Tooltip>
  }

	showLegend = () => {
	  this.showLegendButton.current.blur()
	  this.props.fn.showLegend()
	}

	showByGender = () => {
	  this.showByGenderButton.current.blur()
	  this.props.fn.showByGender()
	}

	showTable = () => {
	  this.showTableButton.current.blur()
	  this.props.fn.showTable()
	}

	openModal = () => {
	  this.openModalButton.current.blur()
	  this.props.fn.modalFunctions().openModal()
	}

	exportChart = eventKey => {
	  const fileType = eventKey.split('_')[0]
	  let gender
	  if (eventKey.split('_').length > 1) {
	    gender = eventKey.split('_')[1]
	  }
	  this.props.fn.exportChart(fileType, gender)
	}

	expandChart = () => {
	  this.expandChartButton.current.blur()
	  this.props.fn.expandChart()
	}

	renderLinkToIndicatorDetail() {
	  const actualURL = this.props.history.location.pathname
	  const layer = APPURL.getLayerFromURL(actualURL)

	  let renderingLink = null
	  if (layer !== 3) {
	    const newURL = APPURL.getIndicatorDetailLink({ url: actualURL, indicator: this.props.indicatorData.id })
	    renderingLink = (
	      <Link to={newURL} className="btn btn-sm btn-primary" role="button">
	        <i className="fal fa-search-plus fa-lg" />
					&nbsp;
	        <span className="ork-u-ml-half">{this.formatMessage(messages.indicatorDetail)}</span>
	      </Link>
	    )
	  }
	  return renderingLink
	}

	renderExportOptions() {
	  let renderingExportOptions = null
	  if (this.props.chartType === 'map' && this.props.showByGender) {
	    renderingExportOptions = (
	      <React.Fragment>
	        <MenuItem header>{this.formatMessage(messages.female)}</MenuItem>
	        <MenuItem eventKey="PNG_Female" onSelect={this.exportChart}>
	          {this.formatMessage(messages.downloadPNG)}
	        </MenuItem>
	        <MenuItem eventKey="JPEG_Female" onSelect={this.exportChart}>
	          {this.formatMessage(messages.downloadJPEG)}
	        </MenuItem>
	        <MenuItem eventKey="PDF_Female" onSelect={this.exportChart}>
	          {this.formatMessage(messages.downloadPDF)}
	        </MenuItem>
	        <MenuItem eventKey="SVG_Female" onSelect={this.exportChart}>
	          {this.formatMessage(messages.downloadSVG)}
	        </MenuItem>
	        <MenuItem eventKey="CSV_Female" onSelect={this.exportChart}>
	          {this.formatMessage(messages.downloadCSV)}
	        </MenuItem>
	        <MenuItem divider />
	        <MenuItem header>{this.formatMessage(messages.male)}</MenuItem>
	        <MenuItem eventKey="PNG_Male" onSelect={this.exportChart}>
	          {this.formatMessage(messages.downloadPNG)}
	        </MenuItem>
	        <MenuItem eventKey="JPEG_Male" onSelect={this.exportChart}>
	          {this.formatMessage(messages.downloadJPEG)}
	        </MenuItem>
	        <MenuItem eventKey="PDF_Male" onSelect={this.exportChart}>
	          {this.formatMessage(messages.downloadPDF)}
	        </MenuItem>
	        <MenuItem eventKey="SVG_Male" onSelect={this.exportChart}>
	          {this.formatMessage(messages.downloadSVG)}
	        </MenuItem>
	        <MenuItem eventKey="CSV_Male" onSelect={this.exportChart}>
	          {this.formatMessage(messages.downloadCSV)}
	        </MenuItem>
	      </React.Fragment>
	    )
	  } else {
	    renderingExportOptions = (
	      <React.Fragment>
	        <MenuItem eventKey="PNG" onSelect={this.exportChart}>
	          {this.formatMessage(messages.downloadPNG)}
	        </MenuItem>
	        <MenuItem eventKey="JPEG" onSelect={this.exportChart}>
	          {this.formatMessage(messages.downloadJPEG)}
	        </MenuItem>
	        <MenuItem eventKey="PDF" onSelect={this.exportChart}>
	          {this.formatMessage(messages.downloadPDF)}
	        </MenuItem>
	        <MenuItem eventKey="SVG" onSelect={this.exportChart}>
	          {this.formatMessage(messages.downloadSVG)}
	        </MenuItem>
	        <MenuItem eventKey="CSV" onSelect={this.exportChart}>
	          {this.formatMessage(messages.downloadCSV)}
	        </MenuItem>
	      </React.Fragment>
	    )
	  }

	  return renderingExportOptions
	}

	render() {
	  return (
	    <div className="panel-footer">
	      <div className="row">
	        <div className="col-sm-4">{this.props.showLinkToDetail ? this.renderLinkToIndicatorDetail() : ""}</div>
	        <div className="col-sm-8">
	          <div className="ork-panel-toolbar btn-group btn-group-sm" role="group" aria-label="toolbar">
	            <OverlayTrigger placement="top" overlay={this.showLegendTooltip}>
	              <button type="button" className="btn btn-default" ref={this.showLegendButton} onClick={this.showLegend}>
	                <i className="fal fa-tag" />
	              </button>
	            </OverlayTrigger>
	            {this.props.indicatorData.relationships.exist ? (
	              <OverlayTrigger placement="top" overlay={this.showByGenderTooltip}>
	                <button type="button" className="btn btn-default" ref={this.showByGenderButton} onClick={this.showByGender}>
	                  <i className="fal fa-venus-mars" />
	                </button>
	              </OverlayTrigger>
	            ) : (
	              ''
	            )}

	            {/* <OverlayTrigger placement="top" overlay={this.showTableTooltip}>
	              <button type="button" className="btn btn-default" ref={this.showTableButton} onClick={this.showTable}>
	                <i className="fal fa-th" />
	              </button>
	            </OverlayTrigger> */}
	            <OverlayTrigger placement="top" overlay={this.openModalTooltip}>
	              <button type="button" className="btn btn-default" ref={this.openModalButton} onClick={this.openModal}>
	                <i className="fal fa-calendar-alt" />
	              </button>
	            </OverlayTrigger>

	            <OverlayTrigger placement="top" overlay={this.exportChartTooltip}>
	              <DropdownButton
	                ref={this.exportChartButton}
	                title={<i className="fal fa-file-export" />}
	                pullRight
	                noCaret
	                dropup={this.props.expanded}
	                id={'exportDropdown'}
	              >
	                {this.renderExportOptions()}
	              </DropdownButton>
	            </OverlayTrigger>

				{this.props.allowFullscreen ? (
	            <OverlayTrigger placement="top" overlay={this.expandChartTooltip}>
	              <button type="button" className="btn btn-default" ref={this.expandChartButton} onClick={this.expandChart}>
	                <i className="fal fa-expand-alt" />
	              </button>
	            </OverlayTrigger>) : ( '' ) }
	            {/* <i className="fal fa-compress-alt"></i> */}
	          </div>
	        </div>
	      </div>
	    </div>
	  )
	}
}

// Set default props
ContentChartFooter.defaultProps = {
	showLinkToDetail: true,
	allowFullscreen: true
}

export default injectIntl(ContentChartFooter)



// WEBPACK FOOTER //
// ./src/modules/Content/ContentChart/ContentChartFooter/ContentChartFooter.jsx